import { apiFetch } from "./api";

export type LoginMode = "both" | "local" | "idm";

export type PublicRuntimeConfig = {
  login_mode: LoginMode;
};

export type RuntimeConfig = {
  features: Record<string, boolean>;
};

export function normalizeLoginMode(value: unknown): LoginMode {
  const mode = String(value ?? "both").trim().toLowerCase();
  return mode === "local" || mode === "idm" || mode === "both" ? mode : "both";
}

export async function fetchPublicRuntimeConfig(): Promise<PublicRuntimeConfig> {
  try {
    const config = await apiFetch<PublicRuntimeConfig>("/api/runtime-config/public", { method: "GET" });
    return { login_mode: normalizeLoginMode(config?.login_mode) };
  } catch {
    return { login_mode: "both" };
  }
}

export async function fetchRuntimeConfig(accessToken: string): Promise<RuntimeConfig> {
  const config = await apiFetch<RuntimeConfig>("/api/runtime-config", { method: "GET" }, accessToken);
  return { features: config?.features ?? {} };
}
